import { STEP, TWO } from '@constants';

export const roundToHalf = (value: number): number => {
  const roundedValue = Math.round(value * TWO) / TWO;

  return Number.isInteger(roundedValue) ? roundedValue : +roundedValue.toFixed(STEP);
};
